<template>
  <tg-button
    :classes="['tg-btn--search']"
    round
    icon="search"
    @click.native="clickHandler"
  >{{$t('component.btn.search')}}</tg-button>
</template>

<script>
import TgButton from "@/components/button/TgButton";

export default {
  components: {
    TgButton
  },
  name: "TgSearchBtn",
  methods: {
    clickHandler(event) {
      this.$emit("click", event);
    }
  }
};
</script>
